import { getSynth } from '../audio/synth';

/**
 * "Open this and play it": a link that should start the music on the page it opens (the home
 * page's Listen button, a feeling's example) records the wish here, inside the click, and
 * unlocks audio while the browser still counts the click as the listener's own gesture.
 * The piece page takes the wish when it opens.
 */
let pending: { pieceId: string; momentId?: string } | null = null;

export function requestPlay(pieceId: string, momentId?: string): void {
  pending = { pieceId, momentId };
  try {
    void getSynth().resume();
  } catch {
    /* audio unavailable: the page opens paused */
  }
}

export function takePlayRequest(pieceId: string): { momentId?: string } | null {
  if (!pending || pending.pieceId !== pieceId) return null;
  const p = pending;
  pending = null;
  return { momentId: p.momentId };
}
